interface IStackableLayerLike {
  meta?: Record<string | number | symbol, unknown>
}

export function getStackableLayerCountWithoutFilePreviews(layers: IStackableLayerLike[]): number {
  return layers.filter(layer => !layer.meta?.isFilePreview).length
}
